import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import MainPanel from '@/components/layout/MainPanel';
import { HeadlineGroup } from '../types';
import { useStore, Stream } from '../store';
import { DataProvider } from '../db/ShapeConnector';

function UnauthenticatedApp() {
  const { initiateGoogleLogin, isAuthenticated } = useAuth();
  const { 
    setSelectedStreamId, 
    setStreams,
    streams
  } = useStore();
  
  // Set up default stream for unauthenticated users
  useEffect(() => {
    // Skip if already authenticated or if streams already exist
    if (isAuthenticated || (streams && streams.length > 0)) {
      return;
    }
    
    // Create a default stream with ID 1
    const defaultStream: Stream = {
      stream_id: 1,
      stream_topic: "Default Stream",
      stream_description: "Default stream for unauthenticated users"
    };
    
    console.log('Setting default stream for unauthenticated user');
    setStreams([defaultStream]);
    
    // Set the selected stream ID to 1
    setSelectedStreamId(1);
  }, [setSelectedStreamId, setStreams, streams, isAuthenticated]);
  
  // Dummy function for headline group selection in unauthenticated state
  const handleHeadlineGroupSelect = (group: HeadlineGroup) => {
    console.log('Headline group selected:', group);
    // In unauthenticated state, we might want to prompt for login
    // or just log the action for now
  };
  
  return (
    <DataProvider>
      <div className="App w-full">
        <div className="min-h-screen w-full flex flex-col md:flex-row">
          {/* MainPanel takes full width on mobile, half on desktop */}
          <div className="w-full md:w-1/2">
            <MainPanel 
              onHeadlineGroupSelect={handleHeadlineGroupSelect} 
              showLoginInHeader={true}
              initiateGoogleLogin={initiateGoogleLogin}
            />
          </div>
          
          {/* Sign-in section hidden on mobile, shown on desktop */}
          <div className="hidden md:flex w-1/2 border-l flex-col items-center justify-center">
            <div className="text-center mb-8">
              <div className="flex items-center justify-center mb-4">
                <img src="/favicon.svg" alt="Lucid Logo" className="w-10 h-10 mr-3" />
                <img src="/google-icon.svg" alt="Google" className="w-8 h-8" />
              </div>
              <h1 className="text-3xl font-bold mb-4">Welcome to Lucid Stream</h1>
              <p className="text-lg text-gray-600 mb-8">Please sign in to continue</p>
              
              <button
                onClick={initiateGoogleLogin}
                className="flex items-center gap-2 px-6 py-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 mx-auto"
              >
                <img src="/google-icon.svg" alt="Google" className="w-5 h-5" />
                <span>Sign in with Google</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </DataProvider>
  );
}

export default UnauthenticatedApp; 